"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Tooltip_component_exports = {};
__export(Tooltip_component_exports, {
  Tooltip: () => Tooltip,
  default: () => Tooltip_component_default
});
module.exports = __toCommonJS(Tooltip_component_exports);
var import_react = __toESM(require("react"));
var import_headless = __toESM(require("@tippyjs/react/headless"));
var import__ = require("./..");
var import_Tooltip = require("./Tooltip.styled");
var _excluded = ["offset", "placement", "arrow", "trigger", "aria", "visible", "interactive", "includeScreenReaderOnlyText", "ariaHidden"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var tooltipRef = /* @__PURE__ */ (0, import_react.createRef)();
var hideOnEsc = {
  name: "hideOnEsc",
  defaultValue: true,
  fn: function fn(instance) {
    function onKeyDown(event) {
      var escKeycode = 27;
      if (event.keyCode === escKeycode) {
        event.stopPropagation();
        event.preventDefault();
        instance.hide();
      }
    }
    return {
      onShow: function onShow() {
        document.addEventListener("keydown", onKeyDown);
        instance.reference.addEventListener("keydown", onKeyDown);
      },
      onHide: function onHide() {
        document.removeEventListener("keydown", onKeyDown);
        instance.reference.removeEventListener("keydown", onKeyDown);
      }
    };
  }
};
var Tooltip = function Tooltip2(_ref) {
  var _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? [2, 5] : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "right-start" : _ref$placement, _ref$arrow = _ref.arrow, arrow = _ref$arrow === void 0 ? true : _ref$arrow, _ref$trigger = _ref.trigger, trigger = _ref$trigger === void 0 ? "mouseenter focusin focus" : _ref$trigger, _ref$aria = _ref.aria, aria = _ref$aria === void 0 ? {
    content: "describedby"
  } : _ref$aria, visible = _ref.visible, _ref$interactive = _ref.interactive, interactive = _ref$interactive === void 0 ? true : _ref$interactive, _ref$includeScreenRea = _ref.includeScreenReaderOnlyText, includeScreenReaderOnlyText = _ref$includeScreenRea === void 0 ? false : _ref$includeScreenRea, _ref$ariaHidden = _ref.ariaHidden, ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden, props = _objectWithoutProperties(_ref, _excluded);
  var holdingPressingTime = 500;
  var isValueString = typeof props.value === "string";
  var getScreenReaderText = function getScreenReaderText2() {
    if (props.ariaLabel) {
      return props.ariaLabel;
    }
    if (props.title) {
      return "".concat(props.title, ", ").concat(isValueString ? props.value : "");
    }
    return isValueString ? props.value : "";
  };
  var getContentToRender = function getContentToRender2(attrs) {
    var _props$content;
    return (_props$content = props.content) !== null && _props$content !== void 0 ? _props$content : /* @__PURE__ */ import_react.default.createElement(import_Tooltip.StyledTooltip, _extends({
      customizedHeight: props.customizedHeight,
      customizedMaxHeight: props.customizedMaxHeight,
      customizedMinHeight: props.customizedMinHeight,
      customizedWidth: props.customizedWidth,
      customizedMinWidth: props.customizedMinWidth,
      customizedMaxWidth: props.customizedMaxWidth,
      title: props.title,
      customizedWordBreak: props.customizedWordBreak,
      textAlign: props.textAlign,
      textSize: props.textSize,
      arrowPadding: props.arrowPadding,
      className: props.className,
      "aria-hidden": ariaHidden
    }, attrs), props.title && /* @__PURE__ */ import_react.default.createElement(import_Tooltip.StyledTooltipTitle, null, props.title), props.value, arrow && /* @__PURE__ */ import_react.default.createElement(import_Tooltip.StyledArrow, {
      className: "arrow",
      "data-popper-arrow": true
    }));
  };
  return /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement(import_headless.default, _extends({
    delay: interactive ? [200, 500] : [200, 300],
    offset,
    placement,
    touch: props.touch || ["hold", holdingPressingTime],
    trigger,
    aria,
    visible,
    plugins: [hideOnEsc],
    ref: tooltipRef,
    interactive,
    render: getContentToRender
  }, props), props.children), includeScreenReaderOnlyText && !ariaHidden && /* @__PURE__ */ import_react.default.createElement(import__.ScreenReaderOnlyText, {
    text: getScreenReaderText()
  }));
};
var Tooltip_component_default = Tooltip;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Tooltip
});
//# sourceMappingURL=Tooltip.component.js.map